<template>
  <v-dialog v-model="visible" persistent @keydown.enter="closeWindow">
    <v-card class="elevation-4 mx-auto" style="width: 100%; max-width: 500px" rounded="lg">
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <component v-if="computedIcon" :is="computedIcon" class="title-icon me-2" :style="{ color: computedTitleColor }" />
          <span :style="{ color: computedTitleColor }">{{ title }}</span>
        </div>
        <ButtonBase iconStyle iconType="cancel" color="grey" @click="closeWindow" />
      </v-card-title>

      <v-card-text class="pa-6 pt-2">
        <p>{{ content }}</p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="d-flex justify-center justify-sm-end ma-2">
        <ButtonBase buttonText="OK" variant="outlined" color="primary" @click="closeWindow" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ButtonBase from "@/components/buttons/ButtonBase.vue";

import { Info, AlertTriangle, AlertCircle, CheckCircle } from "lucide-vue-next";

export default {
  name: "Alert",

  components: {
    ButtonBase,
    Info,
    AlertTriangle,
    AlertCircle,
    CheckCircle,
  },

  props: {
    type: {
      type: String,
      default: "default",
      validator: (value) => ["default", "warning", "success", "delete"].includes(value),
    },
    title: {
      type: String,
      required: true,
    },
    prependIcon: {
      type: Function,
      required: false,
    },
    titleColor: {
      type: String,
      required: false,
    },
    content: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      visible: false,
    };
  },

  computed: {
    computedTitleColor() {
      const colors = {
        delete: "var(--error-color)",
        warning: "var(--warning-color)",
        success: "var(--success-color)",
        default: "var(--primary-color)",
      };
      return this.titleColor || colors[this.type];
    },

    computedIcon() {
      const icons = {
        delete: AlertCircle,
        warning: AlertTriangle,
        success: CheckCircle,
        default: Info,
      };
      return this.prependIcon || icons[this.type];
    },
  },

  methods: {
    openWindow() {
      this.visible = true;
    },

    closeWindow() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.title-icon {
  width: 24px;
  height: 24px;
  stroke-width: 2;
}
</style>
